import React, { FunctionComponent } from 'react';

interface Props extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    code?: string;
}

const LazyFlag: FunctionComponent<Props> = ({ code: locale, ...otherProps }) => {
    const [flag, setFlag] = React.useState();

    React.useEffect(() => {
        const loadSvg = async () => {
            const countryCode = ((locale && locale.length > 3) ? (locale.slice(3)) : (locale ?? '')).toLowerCase();
            const { default: response } = await import(`svg-country-flags/svg/${countryCode}.svg`);
            setFlag(response);
        };
        loadSvg();
    }, [locale]);

    return <img alt={'Flag ' + locale} src={flag} {...otherProps} />;
};
export default LazyFlag;